export const RETAILER_REGISTER_STEP = {
  COMPANY_INFO: 1,
  COMPANY_ACTIVITY: 2
}
